import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, Validators } from '@angular/forms'
import * as fromState from '@tv3/store/state'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { observeOn, startWith } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { widgetFontFamilies } from '@tv3/containers/widgets/shared/constants/font-families'
import { asyncScheduler } from 'rxjs'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-calendar-widget',
  templateUrl: './calendar-widget.component.html',
  styleUrls: ['./calendar-widget.component.scss'],
})
export class CalendarWidgetComponent implements OnInit {
  widgetCode = ''
  trustedWidgetCode: SafeHtml

  rentals$ = this.store.pipe(observeOn(asyncScheduler), select(selectAllRentals))
  calendarsNumOpts = [1, 3, 6, 9, 12]
  fontSizeOpts = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
  fontFamilies = widgetFontFamilies

  form = this.fb.group({
    rentalId: [],
    calendarEndpoint: [environment.config.iCalEndpoint, [Validators.required]],
    calendarNum: [3, [Validators.required]],
    availableColor: ['#BDE0B7', [Validators.required]],
    unavailableColor: ['#ff5c5b', [Validators.required]],
    fontFamily: ['Arial', [Validators.required]],
    fontSize: [14, [Validators.required]],
    sundayFirst: [true, [Validators.required]],
  })

  constructor(
    private store: Store<fromState.State>,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private toast: Toaster,
    private auth: AuthService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.getRawValue())).subscribe((config) => {
      this.buildCode(config)
    })
  }

  buildCode(config) {
    if (!config.rentalId) {
      return
    }
    this.widgetCode =
      `<a class="tokeet-calendar-widget" href="https://www.tokeet.com"
         data-calendar-endpoint="${config.calendarEndpoint}"
         data-rental-id="${config.rentalId}"
         data-rental-account="${this.auth.user.account}"
         data-calendar-months="${config.calendarNum}"
         data-available-color="${config.availableColor}"
         data-unavailable-color="${config.unavailableColor}"
         data-font-family="${config.fontFamily}"
         data-font-size="${config.fontSize}px"
         data-sunday-first="${config.sundayFirst}">` +
      $localize`AdvanceCM Calendar` +
      `</a>
      <script src="https://widgets.tokeet.com/bcalendar_setup.min.js"></script>`

    this.trustedWidgetCode = this.sanitizer.bypassSecurityTrustHtml(this.widgetCode)
  }

  onCopied($event) {
    this.toast.success($localize`Code copied.`)
    this.amplitudeService.logEvent('widget-calendar-copied')
  }

  onColorSelected(key, color) {
    this.form.patchValue({ [key]: color })
  }
}
